import surveyStore from './survey'
import classStore from './class';

export default {
  namespaced:true,
  modules:{
    class: classStore,
    survey: surveyStore
  }
}
